import API from '.';

export default class CashApi {
	static reset = () => {
		const keys = Object.keys(localStorage);
		console.log(keys);
		for (const key of keys) {
			window.RDC.localStorage.removeItem(key);
		}
		API.showToast(true, 'Кэш браузера сброшен. Перезагрузка страницы');
		setTimeout(() => {
			window.location.reload();
		}, 1500);
	};
}
